<template>
  <div v-html="body" />
</template>

<script>
export default {
  name: 'AppText',
  props: {
    col: String,
    body: String,
  }
}
</script>
